var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.788 11.3574C12.758 10.0311 13.1918 8.3875 13.0026 6.75522C12.8134 5.12294 12.0151 3.62222 10.7673 2.55304C9.51946 1.48387 7.91411 0.925028 6.27211 0.988229C4.63012 1.05143 3.07247 1.73202 1.91055 2.89395C0.748621 4.05587 0.0680325 5.61352 0.00483087 7.25551C-0.0583708 8.89751 0.500472 10.5029 1.56964 11.7507C2.63882 12.9985 4.13954 13.7968 5.77182 13.986C7.4041 14.1752 9.04766 13.7414 10.374 12.7714L14.339 16.7364C14.5276 16.9185 14.7802 17.0193 15.0424 17.017C15.3046 17.0147 15.5554 16.9096 15.7408 16.7242C15.9262 16.5388 16.0313 16.288 16.0336 16.0258C16.0359 15.7636 15.9351 15.511 15.753 15.3224L11.788 11.3574ZM2.04595 7.52935C2.04595 6.63934 2.30988 5.76931 2.80434 5.02929C3.29881 4.28927 4.00161 3.71249 4.82388 3.3719C5.64615 3.0313 6.55095 2.94219 7.42386 3.11582C8.29678 3.28945 9.0986 3.71804 9.72793 4.34737C10.3573 4.97671 10.7859 5.77853 10.9595 6.65145C11.1331 7.52436 11.044 8.42916 10.7034 9.25143C10.3628 10.0737 9.78604 10.7765 9.04602 11.271C8.306 11.7654 7.43597 12.0294 6.54596 12.0294C5.35289 12.028 4.20906 11.5535 3.36544 10.7099C2.52181 9.86625 2.04728 8.72242 2.04595 7.52935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.63c81d0fe1df2956357b4fb0eb6f8d46.svg";
export { ForwardRef as ReactComponent };